import { getStock, getTasks } from "actions"
import { getClients } from "clients/services/actions"
import { getClientsData } from "clients/services/reducers"
import { getTasksData } from "common/store/reducers/tasks"
import { renderDate } from "common/services/util"
import filterItemsUseCase from "invoices/services/filterItemsUseCase"
import addInvoiceUseCase from "invoices/services/addInvoiceUseCase"
import updateInvoiceDetailUseCase from "invoices/services/detail/updateInvoiceDetailUseCase"
import { getInvoices } from "invoices/services/store/actions"
import React, { Component } from "react"
import { connect } from "react-redux"
import { referenceField, searchClientsField, searchTasksField, selectPaymentModeField } from "tickets/components/TableFields"
import TableTickets from "tickets/components/TableTickets"
import addTicketUseCase from "tickets/services/addTicketUseCase"
import deleteTicketUseCase from "tickets/services/deleteTicketUseCase"
import { getTicketsAction } from "tickets/services/store/actions"
import { getTicketsList, tickets } from "tickets/services/store/reducers"
import updateTicketUseCase from "tickets/services/updateTicketUseCase"
import { getColumnsTickets } from "tickets/ticketsConfig"
import TicketDetailContainer from "./TicketDetailContainer"
import findTicketDetailByIdUseCase from "tickets/services/detail/findTicketDetailByIdUseCase"
import createPDFTicketUseCase from "tickets/services/createPDFTicket"
import SearchField from "invoices/components/SearchField"
import findTicketByIdUseCase from "tickets/services/findTicketByIdUseCase"
import { history } from 'common/services/history';
import CheckPaid from "tasks/components/CheckPaid"
import sendTicketByEmailUseCase from "tickets/services/sendTicketByEmailUseCase";
import { Checkbox, CircularProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core"
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import SwapHorizIcon from '@material-ui/icons/SwapHoriz'
import { calculateTotalInvoice } from "invoices/services/detail/calculateInvoicesInfo"
import { makeZebraRowStyle } from 'common/services/zebraRowStyle';
import { Typography } from '@material-ui/core';
import InvoiceSummaryPopup from 'invoices/components/InvoiceSummaryPopup';

class TicketsContainer extends Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
        this.state = {
            openDetail: false,
            dataTicket: {},
            dataDetail: {},
            loadingColumns: false,
            tasksSelected: [],
            selectAll: false,
            ticketAlert: null,
            canjeConfirm: null,
            canjeLoading: false,
            canjeSuccess: null
        }
    }

    componentDidMount () {
        const { 
            ticketsMap, tasksMap, clientsMap, 
            getTickets, getTasks, getClients,
            stockList, getStock
        } = this.props

        this.setState({ ...this.state, loadingColumns: true })

        const checkedSelected = (props) => {
            if (!props) {
                return
            }

            return (
                <CheckPaid props={props} 
                    field="selected" 
                    handleChangePaid={this.handleCheckedSelected} 
                    deselect={!this.state.tasksSelected.length}
                    select={this.state.tasksSelected.some(task => task.id === props.id)}
                />
            )
        }

        const checkAll = () => {
            return (
                <Checkbox checked={this.state.selectAll} onChange={e => this.handleSelectAll(e.target.checked) }/>
            )
        }

        this.columns = getColumnsTickets({
            reference: props => referenceField(props, this.handleOpenDetail, "numTicket"),
            searchClients: props => searchClientsField(props, this.props, filterItemsUseCase),
            selectPaymentMode: props => selectPaymentModeField(props, this.handleChangePaymentMode),
            searchTasks: props => searchTasksField(props, this.props, filterItemsUseCase),
            checkedSelected,
            checkAll
        })

        const idToOpen = window.location.search.split("id=")[1]
        if (idToOpen) {
            const numTicket = getTicketsList(ticketsMap).length
            findTicketByIdUseCase({ id: idToOpen })
                .then(task => this.handleOpenDetail({ ...task, numTicket, id: idToOpen }))
                .then(() => history.push('/tickets'))
                .catch(e => {
                    alert("Ha ocurrido un error")
                    console.error(e)
                })
        }

        if (ticketsMap.length === 0) {
            getTickets()
        }

        if (clientsMap.length === 0) {
            getClients()
        }

        if (stockList.length === 0) {
            getStock()
        }
        
        if (tasksMap.length === 0) {
            getTasks();
        }

        if (Object.keys(this.props.invoicesMap || {}).length === 0) {
            this.props.getInvoices()
        }

        this.setState({ ...this.state, loadingColumns: false })
    }

    handleCheckedSelected = (task, flag) => {
        if (flag) {
            this.setState({...this.state, tasksSelected: [...this.state.tasksSelected, task ]})
            this.props.ticketsMap[task.id].selected = true
            return
        }

        const tasksSelected = this.state.tasksSelected.filter(taskSelect => taskSelect.id !== task.id)
        this.setState({...this.state, tasksSelected })
    }

    handleSelectAll = flag => {
        if (flag) {
            const tasksSelected = this.tableRef.current.dataManager.searchedData
            this.setState({...this.state, tasksSelected, selectAll: flag })
            return
        }

        this.setState({...this.state, tasksSelected: [], selectAll: flag })
    }


    handleOpenDetail = async (dataTicket) => {
        const data = await findTicketDetailByIdUseCase(dataTicket.id)
        
        this.setState({
            openDetail: true,
            dataTicket,
            dataDetail: { items: data.data }
        })
    }

    handleChangePaymentMode = (newTicket) => {
        this.setState({ ...this.state, dataTicket: newTicket })
    }

    getCanjeInvoiceCode = (invoicesMap, invoiceCanjeId) => {
        if (!invoiceCanjeId || !invoicesMap) return ''
        const canjeInvoices = Object.entries(invoicesMap)
            .map(([id, data]) => ({ ...data, id }))
            .filter(inv => inv.type === "Canje")
            .sort((a, b) => {
                const aD = a.invoiceDate || Number.MAX_SAFE_INTEGER
                const bD = b.invoiceDate || Number.MAX_SAFE_INTEGER
                return bD - aD
            })
        const idx = canjeInvoices.findIndex(inv => inv.id === invoiceCanjeId)
        if (idx === -1) return ''
        return `C${canjeInvoices.length - idx}`
    }

    getTableTickets = ticketsMap => {
        const ticketsData = getTicketsList(ticketsMap)
        return ticketsData
            .sort((a, b) => {
                const aD = a.ticketDate || Number.MAX_SAFE_INTEGER
                const bD = b.ticketDate || Number.MAX_SAFE_INTEGER
                return bD - aD
            })
            .map((ticket, index) => {
                return {
                    ...ticket,
                    numTicket: ticketsData.length - index,
                    numCanjeInvoice: this.getCanjeInvoiceCode(this.props.invoicesMap, ticket.invoiceCanjeId)
                }
            })
    }

    handleCreateCanjeInvoice = (ticket) => {
        if (ticket.invoiceCanjeId) {
            alert(`Este ticket ya tiene una factura canje asociada: ${ticket.numCanjeInvoice}`)
            return
        }
        this.setState({ canjeConfirm: ticket })
    }

    handleConfirmCanjeInvoice = async () => {
        const ticket = this.state.canjeConfirm
        this.setState({ canjeConfirm: null, canjeLoading: true })
        // Calcular el número ANTES de guardar para evitar que la suscripción
        // de Firestore actualice invoicesMap entre medio y dé un número adelantado
        const nextCanjeNum = `C${Object.values(this.props.invoicesMap || {}).filter(inv => inv.type === "Canje").length + 1}`
        try {
            const ivaPercent = ticket.ivaPercent || 21
            const ticketDateStr = renderDate(ticket.ticketDate)
            const ticketDetail = await findTicketDetailByIdUseCase(ticket.id)
            const ticketDescription = (ticketDetail.data || [])
                .map(d => d.description)
                .filter(Boolean)
                .join(', ')
            const concept = `Factura que sustituye al ticket nº ${ticket.numTicket} con fecha ${ticketDateStr}${ticketDescription ? ` - ${ticketDescription}` : ""}`
            const invoiceId = await addInvoiceUseCase({
                nameClient: ticket.nameClient || "",
                dniClient: ticket.dniClient || "",
                concept,
                totalPrice: ticket.totalPrice,
                basePrice: ticket.basePrice,
                ivaPercent,
                paymentMode: ticket.paymentMode || 2,
                type: "Canje",
            }, false)

            const invoice = { id: invoiceId, ivaPercent }
            const detailItem = {
                description: concept,
                reference: "",
                units: 1,
                unitPrice: ticket.totalPrice || 0,
                iva: true,
            }
            await updateInvoiceDetailUseCase(invoice, ivaPercent, { data: [detailItem] })

            const { numCanjeInvoice, ...ticketToSave } = ticket
            await updateTicketUseCase({ ...ticketToSave, invoiceCanjeId: invoiceId }, ticket)
            this.setState({ canjeLoading: false, canjeSuccess: nextCanjeNum })
        } catch (err) {
            console.error('Error al crear factura canje', err)
            this.setState({ canjeLoading: false })
            alert('Error al crear la factura canje')
        }
    }

    handleTicketPrint = (rowData, operation) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [rowData]
        const sinMetodoPago = tasks.filter(task => !task.paymentMode)
        if (sinMetodoPago.length > 0) {
            const refs = sinMetodoPago.map(t => t.numTicket).join(', ')
            this.setState({ ticketAlert: { message: `No se puede imprimir el ticket nº ${refs} porque no tiene método de pago seleccionado` } })
            return
        }
        tasks.forEach(task => createPDFTicketUseCase({ ticketData: task, operation }))

        this.clearSelected()
    }

    handleAddTicket = async (newTicket) => {
        const id = await addTicketUseCase(newTicket)

        const numTicket = getTicketsList(this.props.ticketsMap).length
        const ticket = await findTicketByIdUseCase({ id })
        this.handleOpenDetail({ ...ticket, id, numTicket })
    }

    handleTaskDelete = async (task) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [task]

        for (let i = 0; i < tasks.length; i++) {
            await deleteTicketUseCase(tasks[i])
        }

        this.clearSelected()
        return true
    }

    handleSendTicketByEmail = async (ticket) => {
        try {
            await sendTicketByEmailUseCase(ticket);
            alert("Ticket enviado por email ✅");
        } catch (err) {
            console.error("❌ Error al enviar ticket por email", err);
            alert(err.message || "Error al enviar el ticket por email");
        }
    };

    clearSelected = () => {
        this.setState({...this.state, tasksSelected: [], selectAll: false })
    }

    render () {
        const { openDetail, dataTicket, dataDetail, tasksSelected } = this.state
        const { ticketsMap } = this.props
        // Zebra + hover + selección por numTicket
        const getRowStyle = makeZebraRowStyle({
            selectedIds: this.state.tasksSelected.map(t => t.numTicket),
            getRowKey: row => row.numTicket,
        });

        let comSelect;

        if (tasksSelected.length > 0 && tasksSelected.length < 10) {
            comSelect = 
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS:</span> { this.state.tasksSelected.map(task => task.numTicket).join(', ') }</span>
                </div>
        } else if (tasksSelected.length >= 10) {
            comSelect = 
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS SELECCIONADAS:</span> { this.state.tasksSelected.length }</span>
                </div>
        }

        return (
        <div style={{ padding: '20px 20px 20px 20px' }}>         
            { comSelect }
            {!this.state.loadingColumns && <TableTickets
                data={this.getTableTickets(ticketsMap)}
                columns={this.columns}
                onTicketsAdd={this.handleAddTicket}
                onTicketsUpdate={updateTicketUseCase}
                onTicketsDelete={this.handleTaskDelete}
                onTicketPrint={this.handleTicketPrint}
                onSendTicketByEmail={this.handleSendTicketByEmail}
                onCreateCanjeInvoice={this.handleCreateCanjeInvoice}
                tableRefProp={this.tableRef}
                getRowStyle={getRowStyle}
                onFilterChange={() => this.forceUpdate()}
            /> }
            <InvoiceSummaryPopup
                tableRef={this.tableRef}
                data={this.getTableTickets(ticketsMap)}
                tasksSelected={tasksSelected}
                filterRow={row => !row.incorrect}
            />
            <Dialog open={Boolean(this.state.canjeConfirm)} onClose={() => this.setState({ canjeConfirm: null })} maxWidth="xs" fullWidth>
                <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24 }}>
                    <SwapHorizIcon style={{ color: '#1976d2', fontSize: 32 }} />
                    <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>Crear factura canje</span>
                </DialogTitle>
                <DialogContent dividers>
                    <DialogContentText style={{ color: '#333', marginBottom: 0, textAlign: 'center' }}>
                        ¿Estás seguro que quieres crear una factura canje
                        {this.state.canjeConfirm?.nameClient ? ` de ${this.state.canjeConfirm.nameClient}` : ''} por importe de <strong>{this.state.canjeConfirm?.totalPrice} €</strong>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                    <Button onClick={() => this.setState({ canjeConfirm: null })} color="default">
                        Cancelar
                    </Button>
                    <Button onClick={this.handleConfirmCanjeInvoice} color="primary" variant="contained" disableElevation>
                        Crear
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={this.state.canjeLoading} maxWidth="xs" fullWidth>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, padding: '32px 24px' }}>
                    <CircularProgress style={{ color: '#1976d2' }} />
                    <span style={{ fontSize: '1rem', color: '#333' }}>Creando factura canje...</span>
                </DialogContent>
            </Dialog>
            <Dialog open={Boolean(this.state.canjeSuccess)} onClose={() => this.setState({ canjeSuccess: null })} maxWidth="xs" fullWidth>
                <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24 }}>
                    <CheckCircleIcon style={{ color: '#10b981', fontSize: 32 }} />
                    <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>Factura canje creada</span>
                </DialogTitle>
                <DialogContent dividers>
                    <DialogContentText style={{ color: '#333', marginBottom: 0, textAlign: 'center' }}>
                        Factura canje <strong>{this.state.canjeSuccess}</strong> creada correctamente.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                    <Button onClick={() => this.setState({ canjeSuccess: null })} color="primary" variant="contained" disableElevation>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={Boolean(this.state.ticketAlert)} onClose={() => this.setState({ ticketAlert: null })} maxWidth="xs" fullWidth>
                <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24 }}>
                    <ErrorIcon style={{ color: '#e53935', fontSize: 32 }} />
                    <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>Error</span>
                </DialogTitle>
                <DialogContent dividers>
                    <DialogContentText style={{ color: '#333', marginBottom: 0, textAlign: 'center' }}>
                        {this.state.ticketAlert?.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                    <Button onClick={() => this.setState({ ticketAlert: null })} color="primary" variant="contained" disableElevation>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            {openDetail && <TicketDetailContainer
                dataTicket={dataTicket}
                dataDetail={dataDetail}
                open={openDetail}
                onClose={() => this.setState({ ...this.state, openDetail: false })}
                onChangePaymentMode={this.handleChangePaymentMode}
            />}
        </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    getTickets: payload => dispatch(getTicketsAction(payload)),
    getTasks: payload => dispatch(getTasks(payload)),
    getStock: payload => dispatch(getStock(payload)),
    getClients: payload => dispatch(getClients(payload)),
    getInvoices: payload => dispatch(getInvoices(payload))
})

const mapStateToProps = state => ({
    ticketsMap: state.tickets.data,
    tasksMap: state.tasks.data,
    stockList: state.stock.data,
    clientsMap: state.clients.data,
    invoicesMap: state.invoices.data
})

export default connect(mapStateToProps, mapDispatchToProps)(TicketsContainer)